import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=48c52d9d"
import script from "./CompanyList.vue?vue&type=script&lang=ts"
export * from "./CompanyList.vue?vue&type=script&lang=ts"
import style0 from "./CompanyList.vue?vue&type=style&index=0&id=48c52d9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports